import { ProductSizeInterface } from '../../../../Interface/ProductSize';
import ProductAttribute from '../../ProductAttribute/ProductAttribute';

export default function ProductAttributes({
  product_size,
  allowBackorder = false,
}: {
  product_size: ProductSizeInterface;
  allowBackorder?: boolean;
}) {
  if (!product_size.product_attributes) return null;

  return (
    <>
      {product_size.product_attributes.map((product_attribute) => (
        <ProductAttribute
          key={product_attribute.id}
          product_size={product_size}
          product_attribute={product_attribute}
          allowBackorder={allowBackorder}
        />
      ))}
    </>
  );
}
